(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    (function () {
    function pairUp() {
      var cards = document.querySelectorAll('.product-info-card');
      if (cards.length < 2) return;

      var a = cards[0];
      var b = cards[1];

      if (a.parentNode !== b.parentNode) return;
      if (a.dataset.fmPaired) return;

      a.dataset.fmPaired = '1';
      b.dataset.fmPaired = '1';

      var row = document.createElement('div');
      row.className = 'fm-paired-row';

      a.parentNode.insertBefore(row, a);
      row.appendChild(a);
      row.appendChild(b);

      a.classList.add('fm-paired-item');
      b.classList.add('fm-paired-item');
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', pairUp);
    } else {
      pairUp();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
